module.exports = __webpack_public_path__ + "img/Intransit.4bf2ddec.png";